'use strict'
class EARoutes {
  constructor(){
    this.route_kv = {}
    this._routes = []
    this.components = {}
  }

  addRoute(r){
    this._routes.push(r)
  }

  parseRoutes(list){
    this._routes = this._routes.concat(this._processRoutes(list,{}))
  }

  _processRoutes(list,defaults){
    var out = []
    for(var idx in list){
      const item = list[idx]
      var name = idx
      item.component = {template:'<router-view></router-view>'}
      if(item.use){
        if(this.components[item.use])
          item.component = this.components[item.use]
        else
          console.error("Could not find component '"+item.use+"'")
      }
      else if(item.vue)
        item.component = ()=>import("components/"+item.vue+".vue")

      let props = item.url?item.url.match(/\:/)!==null:null
      // inherit props from parents
      if(item.parent)
        props = this.route_kv[item.parent].props
      if(!props)
        props = defaults.props
      let r = {
        props: props,
        path: item.url?item.url:"",
        children: item.children?this._processRoutes(item.children,{'props':props}):[],
        name: item.abstract?null:idx,
        meta: item.meta?item.meta:{},
        component: item.component
      }
      //remap short-hand keys
      r.meta.title = item.title
      r.meta.security = item.security
      r.meta.abstract = item.abstract
      this.route_kv[idx] = r
      if(item.parent)
        try{
          this.route_kv[item.parent].children.push(r)
        }catch(e){console.error("Could not find route '"+item.parent+"'!")}
      else
        out.push(r)
    }
    return out
  }

  routes(){
    return this._routes
  }
}

const g_routes = new EARoutes()
export default g_routes
